import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "play-empty-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.059 9.704a1.5 1.5 0 0 1 2.264-1.292l3.882 2.296a1.5 1.5 0 0 1 0 2.583l-3.882 2.295a1.5 1.5 0 0 1-2.264-1.291V9.704Zm5.382 2.295-3.882 2.296V9.704l3.882 2.295Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.25 12A9.75 9.75 0 0 0 12 21.75 9.75 9.75 0 0 0 21.75 12 9.75 9.75 0 0 0 12 2.25 9.75 9.75 0 0 0 2.25 12Zm1.5 0A8.25 8.25 0 0 1 12 3.75 8.25 8.25 0 0 1 20.25 12 8.25 8.25 0 0 1 12 20.25 8.25 8.25 0 0 1 3.75 12Z"
    }, null, -1)
  ])))
}
export default { render: render }